module.exports = __webpack_public_path__ + "img/human-expertise.95dca611.png";